import { render, staticRenderFns } from "./card-other-info.vue?vue&type=template&id=705c18a5&scoped=true"
import script from "./card-other-info.vue?vue&type=script&lang=ts"
export * from "./card-other-info.vue?vue&type=script&lang=ts"
import style0 from "./card-other-info.vue?vue&type=style&index=0&id=705c18a5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705c18a5",
  null
  
)

export default component.exports